import * as React from 'react';
import {
    TextInput,
    Create,
    required,
    BooleanInput,
    SimpleForm,
    SelectInput,
    useCreate,
    BooleanField,
    useUpdate,
    ReferenceInput,
    useNotify,
    minLength,
} from 'react-admin';

import FileUpload from '../../common/inputs/FileUpload';
import { STATUSES } from '../../common/constants';
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import HTMLEditorInput, { validHtml } from '../../common/inputs/HTMLEditorInput';
import { validatePhoneNumber } from '../../common/VideoPlayer/util';
import { goApi } from '../../services';

const OrganizationCreate = () => {
    const [create, { isLoading }] = useCreate();
    const [update, { data, isLoading: updating, error }] = useUpdate();
    const navigate = useNavigate();
    const notify = useNotify();

    const postSave = (data: any) => {
        const payload = {
            ...data,
            primaryUser: {
                ...data.primaryUser,
                status: 'ACTIVE',
            },
        };

        create(
            'organizations',
            { data: payload },
            {
                onSuccess: () => {
                    notify('Organization created successfully', { type: 'success' });
                    navigate('/organizations');
                },
                onError: (error: any) => {
                    notify(error?.message || 'Failed to create organization', { type: 'error' });
                },
            }
        );
    }; return (
        <Create>
            <SimpleForm onSubmit={postSave}>
                <FileUpload type="VIDEO_THUMBNAIL" source="logo" required={true} />
                <TextInput source="name" validate={[required()]} fullWidth />
                <SelectInput source="status" choices={STATUSES} fullWidth />
                <BooleanInput source={'enablePublicRegister'} validate={[required()]} />
                <BooleanInput source={'blockMultiDeviceLogin'} validate={[required()]} />
                <div
                    style={{
                        height: '1px',
                        width: '100%',
                        backgroundColor: '#cccccc',
                        margin: '20px 0',
                    }}
                />
                <Typography>Primary Admin</Typography>
                <TextInput source="primaryUser.firstName" validate={[required()]} fullWidth />
                <TextInput source="primaryUser.lastName" validate={[required()]} fullWidth />
                <TextInput
                    source="primaryUser.phone"
                    validate={[required(), validatePhoneNumber]}
                    fullWidth
                    inputProps={{ maxLength: 10 }}
                    onChange={e => {
                        const onlyNumbers = e.target.value.replace(/\D/g, '');
                        e.target.value = onlyNumbers;
                    }}
                />

                <TextInput source="primaryUser.email" validate={[required()]} fullWidth />
                <TextInput source="primaryUser.password" validate={[required(), minLength(6)]} fullWidth />
                <div
                    style={{
                        height: '1px',
                        width: '100%',
                        backgroundColor: '#cccccc',
                        margin: '20px 0',
                    }}
                />
                <Typography>Social Details</Typography>

                <TextInput source="instagram" fullWidth />
                <TextInput source="telegram" fullWidth />
                <TextInput source="discord" fullWidth />
                <TextInput source="facebook" fullWidth />
                <TextInput source="supportAdditionalPhone" fullWidth />
                <TextInput source="linkedin" fullWidth />
                <TextInput source="youtube" fullWidth />
                <div
                    style={{
                        height: '1px',
                        width: '100%',
                        backgroundColor: '#cccccc',
                        margin: '20px 0',
                    }}
                />
                <Typography>Contact Details</Typography>

                <TextInput source="supportEmail" fullWidth />
                <TextInput source="supportPhone" fullWidth />
                <TextInput source="supportWhatsapp" fullWidth />
                <TextInput source="addressText" fullWidth />
                <TextInput source="addressGoogleMapLink" fullWidth />
                <div
                    style={{
                        height: '1px',
                        width: '100%',
                        backgroundColor: '#cccccc',
                        margin: '20px 0',
                    }}
                />

                <HTMLEditorInput source={'aboutUs'} validate={[required(), validHtml]} fullWidth />
                <HTMLEditorInput
                    source={'termsAndConditions'}
                    validate={[required(), validHtml]}
                    fullWidth
                />
                <HTMLEditorInput
                    source={'privacyPolicies'}
                    validate={[required(), validHtml]}
                    fullWidth
                />
            </SimpleForm>
        </Create>
    );
};

export default OrganizationCreate;
